import { LayoutType } from "../@types";
import { INITIAL_ANALYSIS_SELECTIONS } from "../../modules/samples/components/Reanalyze";

export const LAYOUT_TYPE: { XL: LayoutType; LG: LayoutType; MD: LayoutType } = {
  XL: "xl",
  LG: "lg",
  MD: undefined
};

export const INITIAL_FILE_UPLOAD_ANALYSIS_SELECTIONS = {
  ...INITIAL_ANALYSIS_SELECTIONS,
  tc: true
};

export const DYNAMIC_ANALYSIS_OPTIONS = [
  "rl_auxiliary_analysis",
  "rl_dynamic_analysis",
  "cape",
  "cisco_secure_malware_analytics",
  "cuckoo",
  "fireeye",
  "joe",
  "vmray_tcbase"
];

export const getDynamicAnalysisList = (
  values: typeof INITIAL_FILE_UPLOAD_ANALYSIS_SELECTIONS
): string[] =>
  Object.entries(values)
    .filter(([key]) => DYNAMIC_ANALYSIS_OPTIONS.includes(key))
    .filter(([, value]) => value)
    .map(([key]) => key);
